import React, { useState, useEffect } from "react";
import Table from "../components/Table";

const Users = () => {
  return (
    <div className="w-full bg-white rounded-md p-5">
      <Table />
    </div>
  );
};

export default Users;
